"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./src")); // tslint:disable-next-line:no-import-side-effect no-relative-imports


require("./assets/semantic.flat.min.css");

exports.ANGSTROM_CHAR = String.fromCharCode(0x212b);